<template>
  <div>
    <a-card>
      <a-form-model :model="filterParams" v-bind="fiOptionsFilter" ref="filterForm">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Año')" prop="year" has-feedback
                               :rules="[{ required: true, message: 'Valor requerido' }]">
              <a-input v-model="filterParams.year">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :label="$t('Mes')" prop="month" has-feedback
                               :rules="[{ required: true, message: 'Valor requerido' }]">
              <a-select v-model="filterParams.month">
                <a-select-option v-for="mes in months_name" :key="mes.value">
                  {{ mes.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col v-bind="colSpanFilter">
            <a-form-model-item :wrapper-col="{ span: 16 }">
              <a-button type="primary" @click="filtrar">Filtrar</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <br><br>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :parentData="filterParams"
              :actions="false"
              ref="master"
              modalWidth="70%"
              @params="paramsTable"
    >
      <span slot="estadoRenderer" slot-scope="{text}">
        <a-tag :color="text==='LIQ' ? 'blue' : (text === 'CER' ? 'red' : 'red')">{{text}}</a-tag>
      </span>
      <template slot="customButton">
        <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="DETALLE" key="2">
        <liqmarc-details v-if="LiqMarcInfo" :LiqMarcInfo="LiqMarcInfo"></liqmarc-details>
        <span v-else>Seleccione una registro para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        buttonExcelLoading: false,
        fileNameExcel: 'liq_marc_cerrados',
        paramsT: {},
        endpointExcel: 'liq_marc_/downloadExcel',
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        yearToday: parseInt(moment().format('YYYY')),
        years: [],
        master: {
          endpoint: 'liq_marc',
          tableSetup: {
            allowSelect: true,
            actions: false,
            customSlots: ['estadoRenderer'],
            selectedRows: [],
            tableConfig: {
              rowKey: 'id_liq_marc'
            },
            columns: [
              {title: 'ID empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre del empleado', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'Fecha Inicio Marcacion', dataIndex: 'fecini', sorter: true},
              {title: 'Hora Inicio Marcacion', dataIndex: 'horaini', sorter: true},
              {title: 'Tipo De Dia De Inicio Marcacion', dataIndex: 'tipo_dia_inicio_desc', sorter: true},
              {title: 'Fecha Inicio Marcacion Descanso', dataIndex: 'fecinidesc', sorter: true},
              {title: 'Hora Inicio Marcacion Descanso', dataIndex: 'horainidesc', sorter: true},
              {title: 'Fecha Final Marcacion Descanso', dataIndex: 'ffindesc', sorter: true},
              {title: 'Hora Final Marcacion Descanso', dataIndex: 'horafindesc', sorter: true},
              {title: 'Fecha Fin Marcacion', dataIndex: 'ffin', sorter: true},
              {title: 'Hora Fin Marcacion', dataIndex: 'horafin', sorter: true},
              {title: 'Tipo De Dia De Fin Marcacion', dataIndex: 'tipo_dia_fin_desc', sorter: true},
              {title: 'Año', dataIndex: 'nmyear', sorter: true},
              {title: 'Mes', dataIndex: 'mes_desc', sorter: true},
              {title: 'Periodo', dataIndex: 'nmperiodo', sorter: true},
              {title: 'Origen Marcacion', dataIndex: 'origen_marc_desc', sorter: true},
              {title: 'Grupo', dataIndex: 'grupo', sorter: true},
              {title: 'Puesto', dataIndex: 'puesto', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                fixed: 'right',
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          }
        },
        filterParams: {
          liq_marc_hist: true,
          year: parseInt(moment().format('YYYY')),
          month: parseInt(moment().format('MM')),
          company: null
        },
        fiOptionsFilter: {
          'label-col': {span: 6},
          'wrapper-col': {span: 16}
        },
        colSpanFilter: {
          xs: 8,
          md: 6
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      },
      filtrar () {
        if (!this.$isEmpty(this.filterParams.year) || !this.$isEmpty(this.filterParams.month)) {
          this.filterParams = {
            liq_marc_hist: true,
            year: this.filterParams.year,
            month: this.filterParams.month
          }
        } else {
          this.filterParams = {}
        }
      }
    },
    computed: {
      parentData () {
        return this.filterParams
      },
      LiqMarcInfo () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      paramsExcel () {
        return {...this.paramsT, ...this.parentData, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/LiqMarc/LiqMarcCer.vue